<template>
  <div>
    <Navbar/>
    <h4></h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idTramite" class="form-label">IdTramite</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idTramite" name="idTramite" v-model="datoTramite.idTramite" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idPrestador" class="form-label"> Prestador</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idPrestador" name="idPrestador" v-model="datoTramite.idPrestador">
                      <option v-for="prestador in prestadors" :value="prestador.idPrestador" :key="prestador.idPrestador">
                        {{ prestador.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idServicio" class="form-label"> Servicio</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idServicio" name="idServicio" v-model="datoTramite.idServicio">
                      <option v-for="servicio in servicios" :value="servicio.idServicio" :key="servicio.idServicio">
                        {{ servicio.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoTramite.fechaReg" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaDesde" class="form-label">FechaDesde</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaDesde" name="fechaDesde" v-model="datoTramite.fechaDesde" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaHasta" class="form-label">FechaHasta</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaHasta" name="fechaHasta" v-model="datoTramite.fechaHasta" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="descripcion" class="form-label">Descripcion</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="descripcion" name="descripcion" v-model="datoTramite.descripcion" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarTramite" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditTramite" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdCargaAmb</th>
          <th scope="col">IdTramite</th>
          <th scope="col">Numero</th>
          <th scope="col">NombrePaciente</th>
          <th scope="col">CodVal</th>
          <th scope="col">Cedula</th>
          <th scope="col">Diag01</th>
          <th scope="col">Diag02</th>
          <th scope="col">Diag03</th>
          <th scope="col">Diag04</th>
          <th scope="col">Diag05</th>
          <th scope="col">Motivo</th>
          <th scope="col">Tipo</th>
          <th scope="col">Fecha</th>
          <th scope="col">HoraDesde</th>
          <th scope="col">HoraHasta</th>
          <th scope="col">Laboratorio01</th>
          <th scope="col">Laboratorio02</th>
          <th scope="col">Laboratorio03</th>
          <th scope="col">Laboratorio04</th>
          <th scope="col">Laboratorio05</th>
          <th scope="col">Laboratorio06</th>
          <th scope="col">Laboratorio07</th>
          <th scope="col">Laboratorio08</th>
          <th scope="col">Laboratorio09</th>
          <th scope="col">Laboratorio10</th>
          <th scope="col">Imagen01</th>
          <th scope="col">Imagen02</th>
          <th scope="col">Imagen03</th>
          <th scope="col">Imagen04</th>
          <th scope="col">Imagen05</th>
          <th scope="col">Imagen06</th>
          <th scope="col">Imagen07</th>
          <th scope="col">Imagen08</th>
          <th scope="col">Imagen09</th>
          <th scope="col">Imagen10</th>
          <th scope="col">Estado</th>
          <th scope="col">TramiteFechaReg</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="cargaamb in datosPaginados" :key="cargaamb.idCargaAmb">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(cargaamb.idCargaAmb)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(cargaamb.idCargaAmb)" title="Editar">edit_square</i></td>
          <td>{{cargaamb.idCargaAmb}}</td>
          <td>{{cargaamb.idTramite}}</td>
          <td>{{cargaamb.numero}}</td>
          <td>{{cargaamb.nombrePaciente}}</td>
          <td>{{cargaamb.codVal}}</td>
          <td>{{cargaamb.cedula}}</td>
          <td>{{cargaamb.diag01}}</td>
          <td>{{cargaamb.diag02}}</td>
          <td>{{cargaamb.diag03}}</td>
          <td>{{cargaamb.diag04}}</td>
          <td>{{cargaamb.diag05}}</td>
          <td>{{cargaamb.motivo}}</td>
          <td>{{cargaamb.tipo}}</td>
          <td>{{getFormattedDate(cargaamb.fecha, 'DD/MM/YYYY')}}</td>
          <td>{{cargaamb.horaDesde}}</td>
          <td>{{cargaamb.horaHasta}}</td>
          <td>{{cargaamb.laboratorio01}}</td>
          <td>{{cargaamb.laboratorio02}}</td>
          <td>{{cargaamb.laboratorio03}}</td>
          <td>{{cargaamb.laboratorio04}}</td>
          <td>{{cargaamb.laboratorio05}}</td>
          <td>{{cargaamb.laboratorio06}}</td>
          <td>{{cargaamb.laboratorio07}}</td>
          <td>{{cargaamb.laboratorio08}}</td>
          <td>{{cargaamb.laboratorio09}}</td>
          <td>{{cargaamb.laboratorio10}}</td>
          <td>{{cargaamb.imagen01}}</td>
          <td>{{cargaamb.imagen02}}</td>
          <td>{{cargaamb.imagen03}}</td>
          <td>{{cargaamb.imagen04}}</td>
          <td>{{cargaamb.imagen05}}</td>
          <td>{{cargaamb.imagen06}}</td>
          <td>{{cargaamb.imagen07}}</td>
          <td>{{cargaamb.imagen08}}</td>
          <td>{{cargaamb.imagen09}}</td>
          <td>{{cargaamb.imagen10}}</td>
          <td>{{cargaamb.estado}}</td>
          <td>{{getFormattedDate(cargaamb.tramiteFechaReg, 'DD/MM/YYYY')}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteTramite(cargaamb.idCargaAmb)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idCargaAmb" class="form-label">IdCargaAmb</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idCargaAmb" name="idCargaAmb" v-model="datoCargaAmb.idCargaAmb" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idTramite" class="form-label">IdTramite</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idTramite" name="idTramite" v-model="datoCargaAmb.idTramite" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="numero" class="form-label">Numero</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="numero" name="numero" v-model="datoCargaAmb.numero" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombrePaciente" class="form-label">NombrePaciente</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombrePaciente" name="nombrePaciente" v-model="datoCargaAmb.nombrePaciente" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="codVal" class="form-label">CodVal</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="codVal" name="codVal" v-model="datoCargaAmb.codVal" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="cedula" class="form-label">Cedula</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="cedula" name="cedula" v-model="datoCargaAmb.cedula" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="diag01" class="form-label">Diag01</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="diag01" name="diag01" v-model="datoCargaAmb.diag01" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="diag02" class="form-label">Diag02</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="diag02" name="diag02" v-model="datoCargaAmb.diag02" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="diag03" class="form-label">Diag03</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="diag03" name="diag03" v-model="datoCargaAmb.diag03" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="diag04" class="form-label">Diag04</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="diag04" name="diag04" v-model="datoCargaAmb.diag04" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="diag05" class="form-label">Diag05</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="diag05" name="diag05" v-model="datoCargaAmb.diag05" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="motivo" class="form-label">Motivo</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="motivo" name="motivo" v-model="datoCargaAmb.motivo" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tipo" class="form-label">Tipo</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="tipo" name="tipo" v-model="datoCargaAmb.tipo" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fecha" class="form-label">Fecha</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fecha" name="fecha" v-model="datoCargaAmb.fecha" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="horaDesde" class="form-label">HoraDesde</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="horaDesde" name="horaDesde" v-model="datoCargaAmb.horaDesde" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="horaHasta" class="form-label">HoraHasta</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="horaHasta" name="horaHasta" v-model="datoCargaAmb.horaHasta" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="laboratorio01" class="form-label">Laboratorio01</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="laboratorio01" name="laboratorio01" v-model="datoCargaAmb.laboratorio01" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="laboratorio02" class="form-label">Laboratorio02</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="laboratorio02" name="laboratorio02" v-model="datoCargaAmb.laboratorio02" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="laboratorio03" class="form-label">Laboratorio03</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="laboratorio03" name="laboratorio03" v-model="datoCargaAmb.laboratorio03" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="laboratorio04" class="form-label">Laboratorio04</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="laboratorio04" name="laboratorio04" v-model="datoCargaAmb.laboratorio04" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="laboratorio05" class="form-label">Laboratorio05</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="laboratorio05" name="laboratorio05" v-model="datoCargaAmb.laboratorio05" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="laboratorio06" class="form-label">Laboratorio06</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="laboratorio06" name="laboratorio06" v-model="datoCargaAmb.laboratorio06" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="laboratorio07" class="form-label">Laboratorio07</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="laboratorio07" name="laboratorio07" v-model="datoCargaAmb.laboratorio07" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="laboratorio08" class="form-label">Laboratorio08</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="laboratorio08" name="laboratorio08" v-model="datoCargaAmb.laboratorio08" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="laboratorio09" class="form-label">Laboratorio09</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="laboratorio09" name="laboratorio09" v-model="datoCargaAmb.laboratorio09" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="laboratorio10" class="form-label">Laboratorio10</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="laboratorio10" name="laboratorio10" v-model="datoCargaAmb.laboratorio10" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="imagen01" class="form-label">Imagen01</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="imagen01" name="imagen01" v-model="datoCargaAmb.imagen01" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="imagen02" class="form-label">Imagen02</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="imagen02" name="imagen02" v-model="datoCargaAmb.imagen02" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="imagen03" class="form-label">Imagen03</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="imagen03" name="imagen03" v-model="datoCargaAmb.imagen03" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="imagen04" class="form-label">Imagen04</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="imagen04" name="imagen04" v-model="datoCargaAmb.imagen04" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="imagen05" class="form-label">Imagen05</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="imagen05" name="imagen05" v-model="datoCargaAmb.imagen05" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="imagen06" class="form-label">Imagen06</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="imagen06" name="imagen06" v-model="datoCargaAmb.imagen06" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="imagen07" class="form-label">Imagen07</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="imagen07" name="imagen07" v-model="datoCargaAmb.imagen07" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="imagen08" class="form-label">Imagen08</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="imagen08" name="imagen08" v-model="datoCargaAmb.imagen08" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="imagen09" class="form-label">Imagen09</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="imagen09" name="imagen09" v-model="datoCargaAmb.imagen09" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="imagen10" class="form-label">Imagen10</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="imagen10" name="imagen10" v-model="datoCargaAmb.imagen10" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarCargaAmb" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditCargaAmb" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

    <Footer/>
  </div>
</template>
<script>
import Navbar from '../../components/Navbar.vue'
import Footer from '../../components/Footer.vue'
import { validarForm } from '../../modules/validacionesForms.js';
import dateFormat from '../../modules/dateFormat.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Navbar, Footer
  },
  data () {
    return {
// Variables master
      tramites : [],
      datoTramite : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idTramite: '',
      prestadors : [],
      servicios : [],
// Variables master
// Variables details
      cargaambs : [],
      datoCargaAmb : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      //tramites : [],
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idTramite = this.$route.params.p_idtramite
    this.abrirEditar(this.p_idTramite)
    this.getDataPagina(this.paginaActual)
    this.fetchPrestadors()
    this.fetchServicios()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
// Procedimientos master
    validarForm(){
      const requiredFields = [
        'idPrestador'
        ,'idServicio'
        ,'fechaDesde'
        ,'fechaHasta'
        ,'descripcion'
      ];
      const requiredFieldsText = [
        'idPrestador'
        ,'idServicio'
        ,'fechaDesde'
        ,'fechaHasta'
        ,'descripcion'
      ];
      return validarForm(this.datoTramite, requiredFields, requiredFieldsText);
    },
    async guardarTramite(){
      if(this.validarForm() === 1){
        try {
          await api.post('/tramites', this.datoTramite)
          swal("Correcto!", "Tramite creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditTramite(){
      if(this.validarForm() === 1){
        try {
          await api.post('/tramites', this.datoTramite)
          swal("Correcto!", "Tramite creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoTramite={}
      this.titulo   = 'Crear '
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idTramite){
      this.modalWindow = true
      if(idTramite != null){    
           api.get('/vwtramites/'+idTramite).then(resp=>{
          this.datoTramite = resp.data;
           });
      }
      this.titulo   = 'Editar '
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarTramite(){
      this.$router.push('/Tramite')
    },
// Procedimientos master
// Procedimientos detalle
    totalPaginas(){
      return Math.ceil(this.cargaambs.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwcargaambs/nombre/'+this.nombreBusqueda).then(response=>{
          this.cargaambs=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.cargaambs.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwcargaambs').then(response=>{
      this.cargaambs=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.cargaambs.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      const requiredFields = [
        'idPrestador'
        ,'idServicio'
        ,'fechaDesde'
        ,'fechaHasta'
        ,'descripcion'
      ];
      const requiredFieldsText = [
        'idPrestador'
        ,'idServicio'
        ,'fechaDesde'
        ,'fechaHasta'
        ,'descripcion'
      ];
      return validarForm(this.datoTramite, requiredFields, requiredFieldsText);
    },
    async guardarCargaAmb(){
      if(this.validarForm() === 1){
        try {
          this.datoCargaAmb.idTramite = this.datoTramite.idTramite;
          await api.post('/cargaambs', this.datoCargaAmb)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "CargaAmb creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditCargaAmb(){
      if(this.validarForm() === 1){
        try {
          await api.post('/cargaambs', this.datoCargaAmb)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "CargaAmb creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoCargaAmb={}
      this.titulo   = 'Crear '
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idCargaAmb){
      this.modalWindow = true
      if(idCargaAmb != null){    
           api.get('/vwcargaambs/'+idCargaAmb).then(resp=>{
          this.datoCargaAmb = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar '
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idCargaAmb){
      this.modalWindow = true
      if(idCargaAmb != null){
        this.$router.push('/cargaambmd/'+idCargaAmb)
      }
    },
    async deleteCargaAmb (idCargaAmb) {
      try{
        await api.delete('/cargaambs/'+idCargaAmb)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
    fetchPrestadors() {
      fetch('http://localhost:8080/api/v1/prestadors')
        .then(response => response.json())
        .then(data => {
          this.prestadors = data;
        })
        .catch(error => {
          console.error('Error fetching prestadors:', error);
        });
    },
    fetchServicios() {
      fetch('http://localhost:8080/api/v1/servicios')
        .then(response => response.json())
        .then(data => {
          this.servicios = data;
        })
        .catch(error => {
          console.error('Error fetching servicios:', error);
        });
    },
/*     fetchTramites() {
      fetch('http://localhost:8080/api/v1/tramites')
        .then(response => response.json())
        .then(data => {
          this.tramites = data;
        })
        .catch(error => {
          console.error('Error fetching tramites:', error);
        });
    }, */
  },
}
</script>
